import { DAY, WEEK, MONTH, QUARTER } from 'reporting-data/constants/frequency';
export const FREQUENCY = {
  ALL_TIME: 'ALL_TIME',
  TOTAL: 'TOTAL',
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  WEEKLY_STARTING_MONDAY: 'WEEKLY_STARTING_MONDAY'
};
export const ANALYZE_VIEW = {
  VIEWS: 'VIEWS',
  CLICKS: 'CLICKS',
  SUBMISSIONS: 'SUBMISSIONS'
};
export const VIEWS = {
  [ANALYZE_VIEW.VIEWS]: 'views',
  [ANALYZE_VIEW.CLICKS]: 'clicks',
  [ANALYZE_VIEW.SUBMISSIONS]: 'formSubmissions'
};
export const RATES = {
  [ANALYZE_VIEW.CLICKS]: 'clickRate',
  [ANALYZE_VIEW.SUBMISSIONS]: 'formSubmissionsRate'
};
export const VIEW_TO_UNIFIED_EVENT_MAP = {
  [ANALYZE_VIEW.VIEWS]: 'e_viewed_web_interactive',
  [ANALYZE_VIEW.CLICKS]: 'e_clicked_web_interactive'
};
export const REPORTING_ALLOWED_FREQUENCY = [FREQUENCY.DAILY, FREQUENCY.WEEKLY, FREQUENCY.MONTHLY, FREQUENCY.QUARTERLY];
export const FREQUENCY_REPORTING_OPTIONS = {
  [FREQUENCY.DAILY]: DAY,
  [FREQUENCY.WEEKLY]: WEEK,
  [FREQUENCY.MONTHLY]: MONTH,
  [FREQUENCY.QUARTERLY]: QUARTER
};
export const CTA_UE_SEARCH_REPORT = {
  config: {
    filters: {
      custom: [{
        value: 'false',
        operator: 'EQ',
        property: 'hs_is_bot_event'
      }],
      dateRange: {
        value: {
          date: null,
          endDate: '2024-08-21',
          rangeType: 'CUSTOM',
          startDate: '2024-01-01',
          rollingDays: null,
          rollingDates: null,
          entireCurrentUnit: false
        },
        property: 'date'
      }
    },
    metrics: [{
      property: 'count',
      metricTypes: ['SUM']
    }],
    dataType: 'UNIFIED_EVENTS_QL',
    frequency: 'WEEK',
    configType: 'TIME_SERIES',
    dimensions: ['date'],
    unifiedEventTypeName: 'e_viewed_web_interactive'
  },
  chartType: 'LINE',
  displayParams: {
    stacked: false,
    hideDataLabels: true
  }
};